import {Box, Button, Flex, IconButton, Image, SimpleGrid, Text, useToast} from '@chakra-ui/react'
import {CloseIcon} from '@chakra-ui/icons';
import React from "react";
import {MdCompareArrows} from 'react-icons/md';
import {FiPlusCircle} from 'react-icons/fi';
import Card from "components/card/Card.js";
import {Link, NavLink as ReactLink} from "react-router-dom";

function ReelItem(props) {
    const {index, deleteFromCompared, imageHref, productFamily} = props
    console.log("imageHref", imageHref, "productFamily", productFamily);
    //const textColor = useColorModeValue("white", "navy.700");
    const textColor = "#000000"
    return (
        <Box h={{base: "120px", "2xl": "150px"}}>
            <Flex>
                <Image
                    src={imageHref}
                    // w={{base: "100%", "2xl": "188px", "3xl": "100%"}}
                    // h={{base: "100%", "2xl": "178px", "3xl": "100%"}}
                    maxHeight="100%"
                    h={{base: "100px", "2xl": "130px"}}
                    objectFit='contain'
                    borderRadius='5px'
                    me='15px'
                    //mb={{base: "30px", "2xl": "0px"}}
                    sx={{aspectRatio: "1"}}
                />
                <Text
                    color={textColor}
                    fontWeight='bold'
                    fontSize={{
                        base: "lg",
                        md: "lg",
                        lg: "lg",
                        xl: "lg",
                        "2xl": "lg",
                    }}
                    noOfLines={[1, 2]}>
                    {productFamily}
                </Text>
            </Flex>
            <IconButton
                colorScheme='gray'
                size='xs'
                position="relative"
                top="-140px"
                right="-90px"
                icon={<CloseIcon/>}
                onClick={() => deleteFromCompared(index)}
            />

        </Box>
    )
}

function PlaceHolderReelItem() {
    return (
        <Flex h="100%" direction="row" align="center" grow={1} bgColor="#EEEEEE" borderRadius="10px">

            <Flex direction="column" align="center" gap="4px" grow={1}>
                <FiPlusCircle size={40}/>
                <Text fontSize='lg'>Select a product above to compare</Text>
            </Flex>
        </Flex>
    )
}

function CompareReel(props) {
    const {productsCompared, deleteFromCompared} = props
    const capacity = 2;
    const toast = useToast()
    console.log("productsCompared", productsCompared);
    let productA = productsCompared[0];
    let productB = productsCompared[1];
    const unfilledSlots = capacity - productsCompared.length;

    function handleValidation(e, _productA, _productB) {
        if (_productA === undefined || _productB === undefined) {
            toast({
                title: 'Please select 2 products to compare them together',
                status: 'info', 'isClosable': true,
                duration: 4000
            })
            e.stopPropagation();
        }
    }

    function handleCancellation() {
        for (let i = productsCompared.length - 1; i >= 0; i--) {
            deleteFromCompared(i);
        }
    }

    //const bgColorValue = useColorModeValue("rgba(0, 0, 0, 0.8)", "rgba(244, 244, 244, 0.6)")

    const ConditionalLink = ({children, to, condition, as}) => (!!condition && to)
        ? <Link to={to} as={as}>{children}</Link>
        : <>{children}</>;
    return (
        <Card position="fixed" bottom="17px" pt="10px" pb="10px" height={{base: "200px", "2xl": "250px"}}
              background={"#FFFFFF"} mr="20px" borderRadius="30px" width="85%" ml="7.5%"
              boxShadow="0px 0px 3px rgba(0, 0, 0, 0.13), 0px 3px 12px rgba(0, 0, 0, 0.25), 3px 17px 32px 4px rgba(0, 0, 0, 0.1);">
            <div>
                <SimpleGrid columns={2}>
                    {productsCompared.map((x, idx) => <ReelItem key={idx} index={idx}
                                                                deleteFromCompared={deleteFromCompared} {...x}/>)}
                    {Array.from(Array(unfilledSlots).keys()).map((x, idx) => <PlaceHolderReelItem key={idx}/>)}
                </SimpleGrid>
            </div>
            <Flex mx="auto" gap="40px" mt='20px'>
                <Button bgColor='#F9F9FE' border='1px solid #E1E0FB' onClick={handleCancellation}><Text
                    color='#4338DF'>Cancel</Text></Button>
                <ConditionalLink
                    to={`/home/products/compare?product_family_a=${productA.productFamily}&product_family_b=${productB?.productFamily ?? ""}`}
                    condition={productsCompared.length === 2}
                    as={ReactLink}>
                    <Button onClick={e => handleValidation(e, productA, productB)} leftIcon={<MdCompareArrows/>}>Compare
                        Items</Button>
                </ConditionalLink>

            </Flex>

        </Card>
    )
}

export {ReelItem, CompareReel}